import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { SweepsTasksTable } from '../../../../../../../../../../features/sweeps/clearing/task/sweeps-tasks-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsSweeps,
      label: 'Tasks',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsSweeps>,
  head: () => getPageHead('Sweep Tasks'),
  component: SweepTaskList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsSweeps}
    />
  );
}

function SweepTaskList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <SweepsTasksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
